/* eslint-disable react/no-multi-comp, react/prop-types */

import React from 'react';
import { Field } from 'redux-form';

// Components
import { MoneyInput, DateInput, FileInput } from 'components/forms/form-elements';
import { SubmitButton, DeemphasizedButton } from 'components/widgets/buttons';
import numeral from 'numeral';


// Used by expense bill and return forms
export function DateRow() {
  return (
    <tr className="expense-form-date-row">
      <td />
      <td colSpan="3">
        <Field component={DateInput} name="date" addonLeft="Date" elementClasses="expense-date-input" />
      </td>
      <td className="large-padding-left">
        <Field component={FileInput} name="receipt" buttonLabel="Invoice/Receipt File" />
      </td>
    </tr>
  );
}

// Used by expense bill and return forms
export function ShippingTaxRow({ name, children, moneyInputAddonLeft }) {
  return (
    <tr className="line-item-row">
      <td />
      <td />
      <td />
      <td>
        <Field component={MoneyInput} name={name} addonLeft={moneyInputAddonLeft} />
      </td>
      <td className="large-padding-left">
        {children}
      </td>
    </tr>
  );
}

// Used by all purchase forms
export function SubmitRow({ cancel, submitting, invalid, error, ...props }) {
  return (
    <tr className="line-item-row submit-row">
      <td colSpan="4" className="right-align">
        { cancel && <DeemphasizedButton onClick={cancel}>Cancel</DeemphasizedButton> }
        <SubmitButton showLoading={submitting} />
      </td>
      <td>
        { invalid &&
          ((error && <div className="full-form-invalid-alert">{error}</div>)
          ||
          (props.submitFailed && <div className="full-form-invalid-alert">The form is invalid</div>))
        }
      </td>
    </tr>
  );
}

// Used by all purchase forms
export function TotalRow({ total, children }) {
  return (
    <tr className="line-item-row emphasize no-input-row">
      <td colSpan="4" className="right-align">
        {numeral(total).format('$0,0.00')}
      </td>
      <td className="large-padding-left">
        {children}
      </td>
    </tr>
  );
}
